import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { TierResponse } from '@models/tier';

interface Props {
    data: TierResponse;
}

function TierProgress({ data }:Props) {
    const { currentAccumulatedValue, nextTier, tier } = data;
    const max = nextTier?.threshold || 1;

    return (
        <Column spacing={1} fullWidth >
            <ProgressWrapper>
                <ProgressBar backgroundColor={tier.backgroundColor}
                    width={currentAccumulatedValue / max} />
            </ProgressWrapper>
            <Row fullWidth justify='space-between'>
                <Text color={colors.gray6} size='body-long' fontWeight='medium'>
                    0
                </Text>
                <Text color={colors.gray6} size='body-long' fontWeight='medium'>
                    {nextTier?.threshold || '-'}
                </Text>
            </Row>
        </Column>
    );
}

const ProgressWrapper = styled.div`
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    height: 4px;
    background-color: var(--color-gray3);
    border-radius: 2px;
`;

const ProgressBar = styled.div<{
    backgroundColor?: string;
    width: number;
}>`
    height: 4px;
    border-radius: 2px;
    background-color: ${({ backgroundColor }) => backgroundColor || colors.primary};
    width: ${({ width }) => `${width * 100}%`};
`;

export default TierProgress;
